// src/components/Loader.js
import React from 'react';
import logo from '../images/logo.png';
import './Loader.css';

const Loader = () => (
    <div className="loader-page" role="status" aria-live="polite" aria-label="Loading">
        <div className="loader-content">
            <img src={logo} alt="" className="loader-logo" />
            <div className="loader-dots" aria-hidden="true">
                <span className="loader-dot" />
                <span className="loader-dot" />
                <span className="loader-dot" />
            </div>
            <p className="loader-tagline">SMOKING & CURING</p>
        </div>
    </div>
);

export default Loader;
